import { PHONE } from "shared/constants/media"

const maxWidthQuery = (maxWidth: number) =>
  `@media screen and (max-width: ${maxWidth}px)`
const maxHeightQuery = (maxHeight: number) =>
  `@media screen and (max-height: ${maxHeight}px)`

const mediaQuery = {
  customWidth: maxWidthQuery,
  customHeight: maxHeightQuery,
  mobileDevice: `@media screen and (max-width: ${PHONE}px), (max-height: ${PHONE}px)`,
}

export default mediaQuery
